import { render, staticRenderFns } from "./jzList.vue?vue&type=template&id=35f08c3e&scoped=true&"
import script from "./jzList.vue?vue&type=script&lang=js&"
export * from "./jzList.vue?vue&type=script&lang=js&"
import style0 from "./jzList.vue?vue&type=style&index=0&id=35f08c3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f08c3e",
  null
  
)

export default component.exports